import React, { forwardRef } from 'react';
import { cnMerge } from '../../../utils/utils';
import { Typography } from '../typography/Typography';
import { Checkmark } from '../../../../static/icons/checkmark';
import colors from '../../../../tailwind.colors';

export const Input = forwardRef(
  (
    {
      error,
      title,
      type,
      borderLabel,
      labelClass,
      multiline = false,
      validationCheckmark = false,
      isDirty = false,
      className,
      ...props
    },
    ref
  ) => {
    if (multiline && borderLabel) {
      return (
        <div className="relative my-3 w-full flex">
          <Typography
            htmlFor={title ?? ''}
            className={cnMerge(
              labelClass,
              'absolute -top-2 left-2 bg-white px-1 rounded-md'
            )}
            as="label"
            fontVariant="xs"
          >
            {borderLabel}
          </Typography>
          <textarea
            ref={ref}
            type={type ?? 'text'}
            className={cnMerge(
              `w-full resize-none text-clamp-md h-28 border ${
                error ? 'border-red-500' : 'border-customGray-300'
              } rounded-lg p-3 placeholder:text-customGray-400 placeholder:text-clamp-md placeholder:font-light focus:outline-none`,
              className
            )}
            id={title ?? ''}
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...props}
          />
        </div>
      );
    }
    if (multiline) {
      return (
        <textarea
          ref={ref}
          type={type ?? 'text'}
          className={cnMerge(
            `w-full resize-none text-clamp-md h-28 border ${
              error ? 'border-red-500' : 'border-customGray-300'
            } rounded-lg p-3 placeholder:text-customGray-400 placeholder:text-clamp-md placeholder:font-light focus:outline-none`,
            className
          )}
          id={title ?? ''}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...props}
        />
      );
    }

    if (borderLabel) {
      return (
        <div className="relative my-3 w-full flex">
          <Typography
            htmlFor={title ?? ''}
            className={cnMerge(
              labelClass,
              'absolute -top-2 left-2 bg-white px-1 rounded-md'
            )}
            as="label"
            fontVariant="xs"
          >
            {borderLabel}
          </Typography>
          <input
            id={title ?? ''}
            ref={ref}
            type={type ?? 'text'}
            className={cnMerge(
              className,
              `border bg-transparent text-clamp-md font-normal ${
                error ? 'border-2 border-red-500' : 'border-customGray-300'
              } rounded-md h-14 px-3 py-2 ${
                validationCheckmark && 'pr-12'
              } w-full md:min-w-60 focus:outline-none`
            )}
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...props}
          />
          {validationCheckmark && isDirty && !error && (
            <div className="absolute text-red-900 top-0 right-0 bottom-0 flex items-center w-12 justify-center">
              <Checkmark color={colors.secondary[400]} size={24} />
            </div>
          )}
          {error?.message && (
            <Typography
              htmlFor={title ?? ''}
              className="absolute -bottom-2 left-2 bg-white px-1 rounded-md"
              as="label"
              fontVariant="xs"
            >
              {error.message}
            </Typography>
          )}
        </div>
      );
    }

    return (
      <input
        ref={ref}
        type={type ?? 'text'}
        className={cnMerge(
          `w-full text-clamp-md h-12 border ${
            error ? 'border-red-500' : 'border-customGray-300'
          } rounded-lg px-6 placeholder:text-customGray-400 placeholder:text-clamp-md placeholder:font-light focus:outline-none`
        )}
        id={title ?? ''}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
      />
    );
  }
);
